import * as types from './mutation-types'
import api from '../utils/api'
import fun from '../utils/function'

export default {
  showHeader({ commit }) {
    commit(types.SHOW_HEADER);
  },
  hideHeader({ commit }) {
    commit(types.HIDE_HEADER);
  },
  // 获取用户信息和权限
  async getUserData({ commit }) {
    try {
      // 获取用户信息
      const userInfoRes = await api.user.getUserInfo();
      if (userInfoRes.code === 1 && userInfoRes.data) {
        commit(types.SET_USER_INFO, userInfoRes.data);
      }
      
      // 获取用户权限
      const permissionsRes = await api.user.getUserPermissions();
      if (permissionsRes.code === 1 && permissionsRes.data) {
        commit(types.SET_USER_PERMISSIONS, permissionsRes.data);
      }
      
      return true;
    } catch (error) {
      console.error('获取用户数据失败:', error);
      // 尝试从localStorage恢复
      const cachedUserInfo = fun.getLocalStorage('userInfo');
      const cachedPermissions = fun.getLocalStorage('userPermissions');
      if (cachedUserInfo) {
        commit(types.SET_USER_INFO, cachedUserInfo);
      }
      if (cachedPermissions) {
        commit(types.SET_USER_PERMISSIONS, cachedPermissions);
      }
      return false;
    }
  },
  // 清除用户数据（退出登录时）
  clearUserData({ commit }) {
    commit(types.CLEAR_USER_DATA);
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js